import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import PlaceholderApp from './PlaceholderApp';
import DesignSystemShowcase from './pages/DesignSystemShowcase';
import SSHDPage from './pages/SSHDPage';

// Main App component with routing
function App() {
  // Initialize dark theme on app load
  useEffect(() => {
    const savedTheme = localStorage.getItem('shell-theme') || 'dark';
    document.documentElement.setAttribute('data-theme', savedTheme);
  }, []);

  return (
    <BrowserRouter>
      <Routes>
        {/* Home - Shell placeholder */}
        <Route path="/" element={<PlaceholderApp />} />

        {/* SSH Service Monitor */}
        <Route path="/sshd" element={<SSHDPage />} />

        {/* Arc - Architecture/Design routes */}
        <Route path="/arc/design-system" element={<DesignSystemShowcase />} />

        {/* Fallback to home for unknown routes */}
        <Route path="*" element={<PlaceholderApp />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
